/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconLargeHammer: {
  name: 'large_hammer';
  data: string;
} = {
  name: 'large_hammer',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M514.111 236.451 500.566 259.903 414 209.944 438.617 167.311 317.683 97.581 293.093 140.167 213.179 94.047 226.724 70.597 155.091 29.257 25.866 252.989 97.499 294.329 111.627 269.869 191.564 316.001 166.92 358.681 187.909 370.783 53.924 602.616 160.033 602.616 267.156 416.477 287.854 428.411 312.471 385.778 399.014 435.722 384.886 460.183 456.519 501.523 585.744 277.791z"/></svg>`,
};
